<template> 
  <div class="container mx-auto   pb-10">
    <div class="flex items-center pt-4 max-w-[1400px] mx-auto">
    <button 
    class="px-6 py-3 bg-slate-800 text-white font-medium rounded-lg
          hover:bg-slate-900 transition-all duration-300 ease-in-out
          shadow-md hover:shadow-lg ml-auto text-xs" 
    @click="goToRegister"
  >
    등록하기
  </button> 
    </div>
 
    <Table
      :rows="rows"
      class="w-full max-w-[1400px] mx-auto mt-[13px]"
      :columns="columns"
      :pagination="pagination"
      @update:page="(newPage) => page = newPage"
      @row-click="handleRowClick"
       
    > 
    </Table>
 
  </div>
</template>

<script setup>

import Table from '@/components/ui/NoticeTable.vue'

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const router = useRouter()

const columns = [
  { label: 'NO', value: 'qa_id',  width: '10%' },
  { label: '제목', value: 'title',  width: '50%' },
  { label: '작성일자', value: 'creation_date', width: '20%' },
  { label: '작성자', value: 'user_nm', width: '10%' },
  { label: '답변여부', value: 'reply_yn', width: '10%' } 
];



const rows = ref([])

const store = useStore()
async function handleSearch() { 
 await store.dispatch('qaBoard/fetchQaList') 
 const res = store.getters['qaBoard/allQalist'] 
 rows.value = res
}

handleSearch()

const page = ref(1);

const pagination = computed({
  get() {
    return {
      page: page.value,
      perPage: 10,
      lastPage: Math.ceil(rows.value.length / 10),
    };
  },
  set(val) {
    return val;
  },
});

function goToRegister() {
  router.push('/pub/qa/register');
}

function handleRowClick(row) {
  console.log('클릭된 행 데이터:', row);
  // 예를 들어 해당 상세 페이지로 이동
  router.push({ name: 'QADetail', params: { qa_id: row.qa_id } });
}


</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
